/* 20250717: xt fixing this for rr6 now.. there are changes. 
* Since React Router 6 routes don’t support conditional route rendering directly,
* the easiest fix is in your Callback.js.
* 20260819: add the Stat and Config tabs
*/
import React from 'react';
import PropTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import PrivateRoute from '../Auth/PrivateRoute';
import Login from '../Login/Login';
import Logout from '../Logout/Logout';
import Callback from '../Callback/Callback';
import Dashboard from '../../views/Dashboard/Dashboard';
import Responders from '../../views/Responders/Responders';
import MapTabView from '../../views/MapTabView/MapTabView';
import Reports from '../../views/Reports/Reports';
import Config from '../../views/Config/Config'; // 1/12/26 to add the config navtab
import Stats from '../../views/Stats/Stats';
import Error from '../../views/Error/Error';

const ErrorBoundary = ({ children }) => {
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    if (error) {
      console.error('ErrorBoundary - Caught error:', error);
    }
  }, [error]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return children;
};

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

const Main = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading || !isAuthenticated) {
    return <div>Loading...</div>;
  }


  return (
    <ErrorBoundary>
      <main>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/dashboard/:id" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
          <Route path="/responders" element={<PrivateRoute><Responders /></PrivateRoute>} />
          <Route path="/responders/:id" element={<PrivateRoute><Responders /></PrivateRoute>} />
          <Route path="/maptabview" element={<PrivateRoute><MapTabView /></PrivateRoute>} />
          <Route path="/config" element={<PrivateRoute><Config /></PrivateRoute>} />
          <Route path="/stats" element={<PrivateRoute><Stats /> </PrivateRoute>}/>
          <Route path="*" element={<Error />} />
        </Routes>
      </main>
    </ErrorBoundary>
  );
};

export default Main;
